import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { InputSharedModule } from './../../molecules/input/input.module';
import { FaIconSharedModule } from './../../atoms/fa.icon/fa.icon.module';
import { AlertSharedModule } from './../../molecules/alerts/alerts.module';
import { PostcodeLookUpServiceConfig } from './input.postcode.lookup.service';
import { InputPostcodeLookupSharedComponent } from './input.postcode.lookup.component';

@NgModule({
    declarations: [
        InputPostcodeLookupSharedComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        HttpClientModule,
        AlertSharedModule,
        InputSharedModule,
        FaIconSharedModule
    ],
    exports: [
        InputPostcodeLookupSharedComponent
    ]
})

export class InputPostcodeLookupSharedModule {
    static forRoot(config: PostcodeLookUpServiceConfig): ModuleWithProviders {
        return {
            ngModule: InputPostcodeLookupSharedModule,
            providers: [
                {
                    provide: PostcodeLookUpServiceConfig,
                    useValue: config
                }
            ]
        };
    }
}
